import { Box, Text } from '@qcx/ui';
import { Link } from '../../../components/Link';

interface HeadingInfoProps {
  title: string;
  link: string;
  children: React.ReactNode;
  isViewMore?: boolean;
}

export const HeadingInfo = ({
  title,
  link,
  children,
  isViewMore = true
}: HeadingInfoProps) => {
  return (
    <Box css={{ mb: '$4' }}>
      <Box
        css={{
          flexRow: true,
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Text css={{ color: '$neutral600' }} variant="sm" weight="semibold">
          {title}
        </Text>
        {isViewMore && (
          <Link to={link}>
            <Text
              css={{ color: '$blue700', flexCenter: true, height: 40 }}
              weight="medium"
            >
              Ver mais
            </Text>
          </Link>
        )}
      </Box>
      {children}
    </Box>
  );
};
